import {useEffect, useState} from 'react';
import Image from 'next/image';
import {signIn, signOut, useSession} from 'next-auth/react';
import AppConfig from '../App/AppConfig';
import {updateInterceptors} from '../APIs/interceptors';
import {User} from './User';
import RootStore from '../Core/mobx/RootStore';
import {LoadingSpinner} from '@/components/ui/loading-spinner';
import {Card, CardContent, CardFooter, CardHeader, CardTitle} from '@/components/ui/card';
import {Button} from '@/components/ui/button';
import {GoogleIcon} from '@/components/icons/google';

export default function Authorized({children}: {children: any}) {
    const session: any = useSession();
    const isLoading = session?.status === 'loading';

    // prevent child content from loading before interceptors are set
    const [interceptorSet, setInterceptorSet] = useState(false);

    const handleSessionLoad = () => {
        const error = session?.data?.error;
        if (error) {
            console.log('Signing out due to error ' + error);
            signOut();
        }
        const idToken = session?.data?.id_token;
        if (idToken) {
            updateInterceptors(idToken);

            const data = session.data;
            const {email, name, image} = data.user;
            const token = data.id_token;
            User.Set(email, name, image, token);
            setInterceptorSet(true);
        }
    };

    useEffect(() => {
        handleSessionLoad();
    }, [session]);

    useEffect(() => {
        if (User.Info.email) {
            RootStore.fetchAgentStates();
        }
    }, [User.Info.email]);

    if (session?.data?.user && interceptorSet) {
        return children;
    }

    return (
        <div className="min-h-full h-full flex items-center justify-center">
            {isLoading ? (
                <LoadingSpinner className="h-10 w-10 text-primary" data-testid="loading-spinner" />
            ) : (
                <Card data-testid="login-window" className="w-96 pt-0 bg-white">
                    <CardHeader className="bg-primary text-white py-4 rounded-t-xl ml-[-1px] mr-[-1px]">
                        <CardTitle className="text-lg">
                            {AppConfig.Name} {AppConfig.Version}
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="flex flex-col items-center">
                        <Image
                            src="/img/logo.svg"
                            height={120}
                            width={120}
                            className="w-[40%] self-center"
                            alt="Amplify Logo"
                        />

                        <div className="mt-6">
                            Please login with your personal Amplify Google Account (eg: @beamplify.com or
                            @getamplifylife.com) to access Amplify Platform
                        </div>
                    </CardContent>
                    <CardFooter className="flex justify-center">
                        <Button
                            className="normal-case rounded-full"
                            variant="outline"
                            // color="primary"
                            onClick={() => signIn('google')}
                        >
                            <GoogleIcon className="h-5 w-5" /> Sign in with Google
                        </Button>
                    </CardFooter>
                </Card>
            )}
        </div>
    );
}
